import React, { createContext, useState } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('token'));

    const login = async (adminName, adminCode) => {
        console.log('AuthContext login: Attempting login for admin:', adminName);
        console.log('AuthContext login: Current API Base URL:', api.defaults.baseURL); // Changed to api.defaults.baseURL
        const res = await api.post('/api/admin/login', { adminName, adminCode });
        setToken(res.data.token);
        localStorage.setItem('token', res.data.token);
        // Set the token in the api utility for subsequent requests
        api.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        console.log('AuthContext login: Login successful, token set.');
    };

    const logout = () => {
        console.log('AuthContext logout: Clearing token.');
        localStorage.removeItem('token');
        setToken(null);
        // Remove the token from the api utility
        delete api.defaults.headers.common['Authorization'];
    };

    return (
        <AuthContext.Provider value={{ token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthProvider };
